import { c as _c } from "react/compiler-runtime";
import React, { createContext } from 'react';
import ReactMarkdown, { Options } from 'react-markdown';
import { match } from 'ts-pattern';
import { Mention } from './mention';
import { doTry } from '../promise';
import { twMerge } from 'tailwind-merge';
export type MarkdownOptions = Partial<Omit<Options, 'children'>>;
export const MarkdownContext: React.Context<MarkdownOptions | undefined> = createContext<MarkdownOptions | undefined>(undefined);
export const sharedMarkdownComponents = (options?: {
  appUrl?: string;
}): MarkdownOptions['components'] => ({
  a: ({
    node,
    children
  }) => {
    const props = node?.properties as React.ComponentProps<'a'> | undefined;
    const schema = props?.href ? doTry(() => new URL(props.href!).protocol) : undefined;
    const standard = () => <a {...props} target='_blank'>
          {children}
        </a>;
    if (schema != 'swift:') return standard();
    const m = props?.href ? Mention.fromUrl(props?.href) : undefined;
    return match(m).with({
      type: 'question'
    }, m => options?.appUrl ? <a href={`${options.appUrl}/question/${m.path}`}>{children}</a> : <i>{children}</i>).otherwise(() => <div>{children}</div>); // turn the others into plain text
  }
}) satisfies MarkdownOptions['components'];
export const defaultMarkdownOptions: MarkdownOptions = {
  components: sharedMarkdownComponents(),
  className: 'markdown'
};
export const Markdown = props => {
  const $ = _c(7);
  const ctx = React.useContext(MarkdownContext);
  const t0 = ctx?.className;
  let t1;
  if ($[0] !== props.className || $[1] !== t0) {
    t1 = twMerge(t0, props.className);
    $[0] = props.className;
    $[1] = t0;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const t2 = `markdown ${t1}`;
  let t3;
  if ($[3] !== ctx || $[4] !== props || $[5] !== t2) {
    t3 = <ReactMarkdown {...{
      ...defaultMarkdownOptions,
      ...ctx,
      ...props,
      className: t2
    }} />;
    $[3] = ctx;
    $[4] = props;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};
export namespace MarkdownUtils {
  const nonTextMdRegex = new RegExp(/(!?\[)(.*?)(\])(\(.*?\))/g);
  const m = (s: string) => ' '.repeat(s.length);
  export const maskNonText = (markdown: string) => markdown.replace(nonTextMdRegex, (_, p1, text, p2, p3) => [m(p1), text, m(p2), m(p3)].join(''));
}